<ng-container *ngIf="data; else isLoading">
  <div mat-dialog-content fxLayout="column" class="filter-container">
    <div fxLayout="column" fxFlex="100" fxLayoutGap="20px">
      <div class="title-section margin-bottom-0" fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100">
        <div class="font-bold sparro-grey-800">{{ filter ? 'Filters' : 'Arrange by' }}</div>
        <i class="icon-cross font-xs sparro-grey-800 cursor-pointer" (click)="close()"></i>
      </div>

      <ng-container *ngIf="sort">
        <div class="arrange-section" fxFlex="100">
          <div fxLayout="row wrap">
            <mat-button-toggle-group [(ngModel)]="selectedOrder" name="order" aria-label="Order">
              <mat-button-toggle (change)="toggleOrder($event)" *ngFor="let item of order" [value]="item.type">
                <span>{{ item.name }}</span>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="filter">
        <div fxFlex="100" fxLayout="column" fxLayoutGap="8px">
          <p class="margin-0 sparro-grey-800">Username</p>
          <mat-form-field class="user-form-field" appearance="outline">
            <mat-label class="label">Search by user</mat-label>
            <input matInput [formControl]="userFilterValue" placeholder="Username">
            <i matPrefix class="icon-search sparro-grey-800"></i>
          </mat-form-field>
        </div>
        <div fxFlex="100" fxLayout="column" fxLayoutGap="8px">
          <p class="margin-0 sparro-grey-800">References</p>
          <mat-form-field class="reference-form-field" appearance="outline">
            <mat-label class="label">References</mat-label>
            <input matInput [formControl]="referenceFilterValue" placeholder="title">
            <i matPrefix class="icon-search sparro-grey-800"></i>
          </mat-form-field>
        </div>
        <div class="journal-input-wrapper" fxFlex="100">
          <div fxLayout="column">
            <div fxLayout="row">
              <mat-form-field class="width-100">
                <mat-select [formControl]="journalTypeControl" placeholder="Journal type" [multiple]="true">
                  <mat-select-trigger>
                    {{ journalTypeControl.value ? journalTypeControl.value[0]?.name : '' }}
                    <span *ngIf="journalTypeControl.value?.length > 1">+ {{ journalTypeControl.value.length - 1}}</span>
                  </mat-select-trigger>
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="journalTypeSearchControl"
                      [placeholderLabel]="'Search journals'"
                      [noEntriesFoundLabel]="'No results'"
                      [searching]="false"
                      [enableClearOnEscapePressed]="false">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let journalType of searchedjournalTypes | async" [value]="journalType" (click)="setJournalType(journalType)">
                    {{ journalType.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxLayout="column" fxLayoutGap="12px">
              <div *ngIf="selectedJournalTypes.length > 0" class="sparro-grey-800 selected-clear-all" fxLayout="row" fxLayoutAlign="space-between start">
                <p class="margin-0">Selected</p>
                <div (click)="clearFilter('journalType')" class="clear-filter-btn">
                  <p class="margin-0">Clear all</p>
                </div>
              </div>
              <mat-chip-list fxLayout="row">
                <mat-chip *ngFor="let journalType of selectedJournalTypes" [selectable]="selectable"
                  [removable]="removable" class="chip-section font-sm">
                  {{ journalType.name | titlecase }}
                  <i class="icon-cross font-md" (click)="removeJournalType(journalType)" *ngIf="removable"></i>
                </mat-chip>
              </mat-chip-list>
            </div>
          </div>
        </div>
        <div class="discipline-input-wrapper" fxFlex="100" fxLayout="column">
          <mat-form-field class="width-100">
            <mat-label>Discipline</mat-label>
            <mat-select [formControl]="disciplineControl" [multiple]="true">
              <mat-select-trigger>
                {{ disciplineControl.value ? disciplineControl.value[0].name : '' }}
                <span *ngIf="disciplineControl.value?.length > 1"> + {{ disciplineControl.value.length - 1}}</span>
              </mat-select-trigger>
              <mat-option>
                <ngx-mat-select-search [formControl]="disciplineSearchControl" [placeholderLabel]="'Search disciplines'"
                  [noEntriesFoundLabel]="'No results'" [searching]="false" [enableClearOnEscapePressed]="false">
                </ngx-mat-select-search>
              </mat-option>
              <mat-option *ngFor="let discipline of searchedDisciplines | async" [value]="discipline"
                (click)="setDiscipline(discipline)">
                {{ discipline.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div fxLayout="column" fxLayoutGap="12px">
            <div *ngIf="selectedDisciplines.length > 0" class="sparro-grey-800 selected-clear-all" fxLayout="row" fxLayoutAlign="space-between start">
              <p class="margin-0">Selected</p>
              <div (click)="clearFilter('discipline')" class="clear-filter-btn">
                <p class="margin-0">Clear all</p>
              </div>
            </div>
            <mat-chip-list fxLayout="row">
              <mat-chip *ngFor="let discipline of selectedDisciplines" [selectable]="selectable" [removable]="removable"
                class="chip-section">
                {{ discipline.name | titlecase }}
                <i class="icon-cross font-md" (click)="removeDiscipline(discipline)" *ngIf="removable"></i>
              </mat-chip>
            </mat-chip-list>
          </div>
        </div>
        <mat-form-field class="organized-comp-form-field font-xs-static width-100" appearance="outline">
          <mat-label>Editorial</mat-label>
          <input matInput type="text" [disabled]="true">
          <mat-checkbox matSuffix class="competitions-checkbox" (change)="setEditorial($event)" 
            [(ngModel)]="editorial" [color]="'warn'">
          </mat-checkbox>
        </mat-form-field>
        <div fxFlex="100" fxLayout="column" fxLayoutGap="12px">
          <p class="margin-0 filter-title sparro-grey-800">Date published</p>
          <div fxFlex="100" fxLayout="column" fxLayoutGap="25px">
            <uni-date-range-filter (dateRangeOutput)="setDateRange($event)" [placeholder]="'Select date/duration'"
              [startDate]="startDate" [endDate]="endDate" [selectedRange]="selectedRange">
            </uni-date-range-filter>
            <ng-container *ngIf="selectedRange">
              <mat-chip-list fxLayout="row">
                <mat-chip  [selectable]="selectable"
                  [removable]="removable" class="chip-section font-sm">
                  {{ dateRange }}
                  <i class="icon-cross font-md" (click)="removeDateRange()" *ngIf="removable"></i>
                </mat-chip>
              </mat-chip-list>
            </ng-container>
          </div>
        </div>
      </ng-container>
      <div fxLayout="row" style="justify-content:flex-end" fxFlex="100" fxLayoutGap="12px">
        <uni-navigation-button default="Reset" button_class="secondary" (click)="reset(sort)">
        </uni-navigation-button>

        <uni-navigation-button default="Apply" button_class="primary" (click)="applyFilters()">
        </uni-navigation-button>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #isLoading>
  <div fxLayout="row" fxLayoutAlign="center center" style="height: 200px">
    <uni-loader></uni-loader>
  </div>
</ng-template>
